<template>
    <span v-if="error" class="block text-red-800 dark:text-red-300">{{ error }}</span>
</template>

<script>
export default {
    name: "Error",
    props: {
        error: String,
    },
};
</script>
